/**
 * Bank-transfer payment instructions modal.
 */
import { ShoppingBag, X } from "@phosphor-icons/react";
import { fmt } from "@/lib/api";
import { toast } from "sonner";

export function BankTransferModal({ bank, producto, precio, moneda, negocio, onClose, onApartar }) {
  const copyField = (text, label) => {
    try {
      navigator.clipboard.writeText(text);
      toast.success(`${label} copiado`);
    } catch {
      toast.error("No se pudo copiar");
    }
  };
  const row = (label, value, testid) =>
    value ? (
      <div className="flex items-start justify-between gap-3 py-2 border-b border-zinc-100 last:border-0">
        <div className="min-w-0">
          <div className="overline">{label}</div>
          <div className="text-sm font-mono mt-0.5 break-all" data-testid={testid}>
            {value}
          </div>
        </div>
        <button
          type="button"
          onClick={() => copyField(value, label)}
          className="text-xs text-klein hover:underline shrink-0 mt-1"
          data-testid={`${testid}-copy`}
        >
          Copiar
        </button>
      </div>
    ) : null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="bank-transfer-modal"
    >
      <div
        className="bg-white max-w-md w-full p-6 border border-zinc-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 mb-3">
          <div>
            <div className="overline text-[#0D47A1]">Transferencia bancaria</div>
            <div className="h-display text-xl font-bold mt-0.5">Datos para pagar</div>
            <div className="text-xs text-muted2 mt-1">
              {negocio} · {producto} · <strong>{fmt(precio, moneda)}</strong>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-zinc-100"
            data-testid="bank-modal-close"
          >
            <X size={16} weight="bold" />
          </button>
        </div>

        <div className="border border-zinc-200 px-4">
          {row("Titular", bank.titular, "bank-titular")}
          {row("Banco", bank.banco, "bank-banco")}
          {row("CLABE", bank.clabe, "bank-clabe")}
          {row("Cuenta", bank.cuenta, "bank-cuenta")}
          {row("Concepto sugerido", bank.concepto, "bank-concepto")}
        </div>

        <div className="text-[11px] text-muted2 bg-zinc-50 border border-zinc-200 px-3 py-2 mt-3">
          Una vez hecha la transferencia, comparte tu comprobante con el vendedor. Aparta el producto para que no se venda mientras llega tu pago.
        </div>

        <button
          type="button"
          onClick={onApartar}
          className="mt-4 w-full inline-flex items-center justify-center gap-2 px-4 py-3 bg-klein text-white text-sm font-semibold hover:bg-klein-dark"
          data-testid="bank-modal-apartar"
        >
          <ShoppingBag size={16} /> Apartar el producto
        </button>
      </div>
    </div>
  );
}
